import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyState = () => (
  <Box alignItems="center" padding="s32" gap="s4">
    <Text.Normal weight="medium" color="grey800">
      {i18n.t('command_bar.results.empty_state.title')}
    </Text.Normal>
    <Text.Normal color="grey800">
      {i18n.t('command_bar.results.empty_state.description')}
    </Text.Normal>
  </Box>
)

export default EmptyState
